import React from 'react';
import _ from 'lodash';
import { useMutation, useQuery } from 'react-fetching-library';
import { Box, Modal, Card, CardContent, CardHeader, IconButton, Typography } from '@mui/material';
import { getTransportSumAction } from '../../../services/request';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import CloseIcon from '@mui/icons-material/Close';
import toast from 'react-hot-toast';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

export default function TransportSumReportModal({ open, handleClose }) {
  const { loading, payload, error } = useQuery(getTransportSumAction());
  const [data, setData] = React.useState({ 'departure': 0, 'return': 0 });

  React.useEffect(() => {
    if (!error && !loading) {
      setData(payload);
    }
  }, [loading]);


  return (
    <Modal open={open} onClose={handleClose}>
      <Card sx={{ ...style, width: '400px' }}>
        <CardHeader
          title="Suma transportów"
          action={
            <IconButton color="primary" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          }
        />
        <CardContent style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <Typography>Transport wyjazd: {data.departure} zł</Typography>
          <Typography>Transport powrót: {data.return} zł</Typography>
        </CardContent>
      </Card>
    </Modal>);
};
